import { connectHook } from 'app/common/components/connect-hook';
import { ToolEditRun } from './tool-edit-run';
import { useToolEditRun } from './tool-edit-run-hook';

export default connectHook(ToolEditRun, useToolEditRun);
